
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delete-account",
      function () {
        return require("private-next-pages/delete-account/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delete-account"])
      });
    }
  